<!-- by coa -->
<template>
  <div>
    <div
         v-bind:class="[
        detail ? detailShow + '  w-full mb-base' : '',
        detailHide,
      ]"
    >
      <vs-table
        search
        stripe
        border
        description
        :sst="true"
        :data="table.data"
        :max-items="table.length"
        :total="table.total"
        @search="handleSearch"
        @change-page="handleChangePage"
      >
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-3
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{ this.table.start }} - {{ this.table.end }} of
                {{ this.table.total }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="item in table.limits"
                :key="item"
                @click="handleChangelength(item)"
              >
                <span>{{ item }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <div class="btn-group ml-5">
            <vs-button
              color="primary"
              type="filled"
              @click="confirmGetData()"
              :disabled="isProcessing"
              >Get Data</vs-button
            >
          </div>
          <div class="btn-group ml-10">
            <vs-button
              color="success"
              type="filled"
              @click="viewData()"
              >View Data</vs-button
            >
          </div>
          <div class="btn-group ml-1">
            <vs-button
              color="success"
              type="border"
              @click="handleExport('excel')"
              >Export</vs-button
            >
          </div>
        </template>
        <template slot="thead">
          <vs-th style="text-align: center;"
            v-for="(head, index) in this.table.heads"
            :key="index"
            :sort-key="head.field"
            >{{ head.title }}</vs-th
          >
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td
              v-for="(head, index) in table.heads" :key="index" :data="data[indextr][head.field]">
              <!-- <span v-if="head.field.toString().includes('date')">{{ dateFormat(data[indextr][head.field]) }}</span> -->
              <span v-if="['zh_debit_value', 'zh_credit_value', 'api_debit_value', 'api_credit_value', 'odoo_debit_value', 'odoo_credit_value', 'sum_credit_odoo', 'sum_debit_odoo', 'delta_debit_zh_odoo_api', 'delta_credit_zh_odoo_api', 'delta_debit_zh_odoo_sum', 'delta_credit_zh_odoo_sum'].includes(head.field)">{{ formatCurrency(data[indextr][head.field]) }}</span>
              <span v-else-if="['detail_document'].includes(head.field)">
                <!-- <vs-td class="whitespace-no-wrap"> -->
                  <template>
                    <vx-tooltip text="Detail Document">
                      <vs-button
                        type="line"
                        icon-pack="feather"
                        @click.stop="
                          handleOpenForm(
                            indextr
                          )
                        "
                        icon="icon-eye"
                      />
                    </vx-tooltip>
                  </template>
                <!-- </vs-td> -->
              </span>
              <span v-else>{{ data[indextr][head.field] }}</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        style="padding-top: 5px"
        :total="table.totalPage"
        v-model="setPage"
      />
    </div>

    <!-- Confirmation Popup for Get Data -->
    <vs-prompt
      color="primary"
      title="Confirmation"
      :active.sync="activePromptGetData"
      @accept="getData"
      @cancel="activePromptGetData = false"
      @close="activePromptGetData = false"
    >
      <div class="con-example-prompt">
        <p>Are you sure you want to get data period {{ this.filterPeriod }}?</p>
      </div>
    </vs-prompt>
    <transition name="detail-fade">
      <div
        v-if="detail"
        v-bind:class="[
          detail ? detailShow + '  w-full mb-base' : '',
          detailHide,
        ]"
      >
        <vs-row>
          <vs-col
            style="padding-bottom: 8px"
            vs-offset="8"
            vs-type="flex"
            vs-justify="rigth"
            vs-align="rigth"
            vs-w="4"
          >
            <vs-button
              class="ml-auto"
              size="small"
              v-on:click="handleClose"
              color="grey"
              icon-pack="feather"
              icon="icon-x-square"
            >Close
            </vs-button>
          </vs-col>
          <!-- form component -->
         </vs-row>
      </div>
    </transition>

    <vs-popup fullscreen title="Log Details" :active.sync="detail">
			<div class="vx-row mb-6">
				<div class="vx-col w-full" v-if="detail">
					<datatableDetail :selectedData="selectedData"></datatableDetail>
				</div>
			</div>
		</vs-popup>
  </div>
</template>
<script>

// import { AgGridVue } from "ag-grid-vue";
// import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import datatableDetail from "./datatable-detail.vue";
import moment from "moment";
export default {
  components: {
    datatableDetail,
  },
  props: {
    baseUrl: {
      type: String,
    },
    filterPeriod: {
      type: String,
    },
    ouCode: {
      type: [String, Array],
    },
    coaCode: {
      type: [String, Array],
    },
    lastUpdate: {
      type: String,
      default: null,
    },
    // draw: {
    //   type: Number,
    // },
  },
  data() {
    return {
      deleteId: null,
      table: this.tableDefaultState(),
      detailShow: "core vx-col ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      detail: false,
      closeDetail: false,
      activePromptDetail: false,
      selectedData: null,
      notes: "",
      activePromptGetData: false,
      draw: 0,
    };
  },
  methods: {
    confirmGetData() {
      this.activePromptGetData = true;
    },
    handleClose() {
      this.detail = false;
      this.componentKey += 1;
    },
    handleOpenForm(indextr) {
      this.detail = true;
      this.activePromptDetail = true;
      this.selectedData = []
      // this.detailData = []

      this.$vs.loading();
      this.$http
        .get(this.baseUrl + "/detail", {
          params: {
            period: this.table.data[indextr].period,
            coa_code: this.table.data[indextr].coa_code,
            ou_code: this.table.data[indextr].ou_code,
          },
        })
        .then((resp) => {
          this.tableDefaultState();
          if (resp.status === "success") {
            this.selectedData = resp.data.records
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
          this.$forceUpdate()
        });
    },
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "data.coa_code",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
        heads: [
          { field: "detail_document", title: "Detail Doc" },
          { field: "period", title: "Period" },
          { field: "ou", title: "Operating Unit" },
          { field: "coa", title: "COA" },
          { field: "zh_debit_value", title: "Value ZH (Debit)" },
          { field: "zh_credit_value", title: "Value ZH (Credit)" },
          { field: "api_debit_value", title: "Odoo API (Debit)" },
          { field: "api_credit_value", title: "Odoo API (Credit)" },
          { field: "odoo_debit_value", title: "Odoo Input (Debit)" },
          { field: "odoo_credit_value", title: "Odoo Input (Credit)" },
          { field: "sum_debit_odoo", title: "Sum Odoo (Debit)" },
          { field: "sum_credit_odoo", title: "Sum Odoo (Credit)" },
          { field: "delta_debit_zh_odoo_api", title: "Delta ZH vs Odoo API (Debit)" },
          { field: "delta_credit_zh_odoo_api", title: "Delta ZH vs Odoo API (Credit)" },
          { field: "delta_debit_zh_odoo_sum", title: "Delta ZH vs Odoo Sum (Debit)" },
          { field: "delta_credit_zh_odoo_sum", title: "Delta ZH vs Odoo Sum (Credit)" },
        ],
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.viewData();
    },
    handleChangePage(page) {
      this.table.page = page;
      if (this.draw > 0) {
        this.viewData();
      }
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.viewData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.viewData();
    },
    viewData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl + "/table", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            period: this.filterPeriod,
            coa_code: this.coaCode,
            ou_code: this.ouCode,
          },
        })
        .then((resp) => {
          this.tableDefaultState();
          if (resp.status === "success") {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records || resp.data.total_record !==0 ? resp.data.records : [];
            this.setStartEnd();
            this.$vs.loading.close();
            this.draw++;
          } else {
            this.table.total = 0;
            this.table.totalPage = 0;
            this.table.totalSearch = 0;
            this.table.length = 0;
            this.table.data =     [];
            this.setStartEnd();
            this.$vs.loading.close();
          }
          this.$forceUpdate()
        });
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl + "/get-data", {
          params: {
            period: this.filterPeriod,
          },
        })
        .then((resp) => {
          this.tableDefaultState();
          if (resp.status === "success") {
            this.$emit('update-last-update', this.filterPeriod);
            // jika this.lastUpdate di parent memiliki value "Processing", maka tombol Get Data akan di-disable
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
          this.$forceUpdate()
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    // dateFormat(val) {
    //   if (!val || typeof val === "undefined" || val.toString().includes("0001")) {
    //     return  ""
    //   }
    //   return moment(val).format("YYYY-MM-DD");
    // },
    // dateFormat(date) {
    //   if (date) {
    //     return moment(date).format("DD MMM YYYY");
    //   }
    //   return "";
    // },
    formatCurrency(value) {
      if (value === null || value === undefined || value === '') {
        return '0';
      }
      return parseFloat(value).toLocaleString('en-US');
    },
    handleExport(file) {
      this.$vs.loading();
      var filetitle =
        "GL_MONITORING_" +  this.filterPeriod;
      this.$http
        .get(this.baseUrl + "/export", {
          params: {
            period: this.filterPeriod,
            title: filetitle,
            coa_code: this.coaCode,
            ou_code: this.ouCode,
            type: "gl-monitoring"
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.status == "error") {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Processing",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          }
        });
    },
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
    isProcessing() {
      return this.lastUpdate === "Processing";
    }
  },
};
</script>
